import React from 'react';
import { useTranslation } from 'react-i18next';

import type { RadarSeverity } from '../../../types/radar';
import SeverityIndicator from './SeverityIndicator';

import './_severity-badge.scss';

type SeverityBadgeProps = {
  severity: RadarSeverity;
};

function SeverityBadge({ severity }: SeverityBadgeProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  const levelKey = severity === 'high' ? 'radar_severity_high' : severity === 'medium' ? 'radar_severity_medium' : 'radar_severity_low';

  return (
    <div className="severity-badge">
      <span className="severity-badge__label">{t('chatbot:radar_severity_label')}:</span>
      <div className="severity-badge__row">
        <SeverityIndicator severity={severity} />
        <span className={`severity-badge__level severity-badge__level--${severity}`}>{t(`chatbot:${levelKey}`)}</span>
      </div>
    </div>
  );
}

export default SeverityBadge;
